import SelectDropdown from '@/components/component/Reuse/SelectDropdown/SelectDropdown.vue'
import InfiniteLoading from 'vue-infinite-loading';
import { getShortUrlById, getReportingGroups, getMetaDossierList, getMetaCollectionList, updateShortUrl, isUrlReachable, updateReportingGroup } from '@/libs/api/api'
import pageRoutes from '@/libs/constant/pageRoutes'
import { getImageUrl, onError, getDate, urlValidation, loader, message, errorHandler, logout } from '@/libs/helper'
import { isEmpty } from 'lodash'
import constants from '@/libs/constant/constants';
import {mapGetters} from 'vuex';
import permissions from '@/libs/constant/permissions'

export default {
    name: 'UrlDashboard',

    beforeRouteEnter(to, from, next) {
        next(vm => {
          vm.prevRoute = from
        })
    },

    components: {
        SelectDropdown,
        InfiniteLoading
    },

    props: {
        getLocationImageUrl: {
            type: Function,
            default: () => {}
        },
        handleLocationRedirection: {
            type: Function,
            default: () => {}
        },
        getLocationRouteName: {
            type: Function,
            default: () => {}
        },
        details: {
            type: Object,
            default : () => {}
        }
    },

    watch: {
        details () {
            this.routeToPreviousPage()
            this.optionsOrganisation[0].name =  `${this.details.type ? this.details.screen_name: this.details.name} > overview`
        }
    },

    created () {
        this.EXTERNAL = 'EXTERNAL'
        this.INTERNAL = 'INTERNAL'
        this.baseUrl = process.env.VUE_APP_ENV === 'production' ? 'accura.onl' : process.env.VUE_APP_ENV === 'staging' ? 'web-staging.accura.onl' : 'web-dev.accura.onl'
    },

    beforeMount () {
        this.fetchShortUrl()
        this.fetchreportingGroups()
        this.fetchCollections(true)
        this.fetchDossiers(true)
    },

    data() {
        return {
            getDate,
            getImageUrl, 
            onError,
            url: {},
            isFolded: false,
            primary: this.INTERNAL || 'INTERNAL',
            backup: this.INTERNAL || 'INTERNAL',
            registeredUrlDropdownValue: '',
            short_url: {},
            prevRoute: null,
            reportingGroups: [],
            reportingGroupValue: '',
            primary_url: {},
            backup_url: {},
            collectionList: [],
            dossierList: [],
            page: 1,
            skip: 0,
            limit: 10,
            dossierSkip: 0,
            isFetchingCollections: false,
            isLoadMore: true,
            isFetchingDossiers: false,
            isLoadMoreDossiers: true,
            urlPopoverPrimary: false,
            urlPopoverBackup: false,
            primaryExternalURL: '',
            backupExternalURL: '',
            isPrimaryExternalUrlVerified: false,
            isBackupExternalUrlVerified: false,
            optionsOrganisation:[
                {
                    name: `${this.details.type ? this.details.screen_name: this.details.name} > overview`,
                    id: 'Option1'
                }, 
                // {
                //     name: 'Organisation > About',
                //     id: 'Option2'
                // }
            ],
            markedReporting: [],
            permissions: permissions
        }
    },
    
    computed: {
        isDashboard () {
            if (this.$route.name === pageRoutes.shortURLDashboard) return true
            return false
        },
        isDisabledCollections () {
            return !this.isLoadMore || this.isFetchingCollections
        },
        isDisabledDossiers () {
            return !this.isLoadMoreDossiers || this.isFetchingDossiers
        },
        ...mapGetters({
            userInformation: 'getUserInformation', hasPermission: 'hasPermission'
        }),
    },

    methods: {
        async fetchShortUrl () {
            if (!this.hasPermission(permissions.getShortUrlById)) return;
            let response = await getShortUrlById(this.$route.params.id)
            this.short_url = response.short_url || {}
            this.setShortUrlFields()
        },

        setShortUrlFields () {
            if (!isEmpty(this.short_url)) {
                const short = this.short_url
                this.primary = (short.primary_url && short.primary_url.redirection_type) || this.INTERNAL
                this.backup = (short.backup_url && short.backup_url.redirection_type) || this.INTERNAL
                
                if (this.primary === this.EXTERNAL) {
                    this.isPrimaryExternalUrlVerified = true
                    this.primaryExternalURL = (short.primary_url && short.primary_url.external_url) || ''
                }

                if (this.backup === this.EXTERNAL) {
                    this.isBackupExternalUrlVerified = true
                    this.backupExternalURL = (short.backup_url && short.backup_url.external_url) || ''
                }

                if (!isEmpty(short.primary_url)) {
                    this.primary_url = short.primary_url
                    let label = `${this.details.type ? this.details.screen_name: this.details.name} > overview`
                    if (this.primary_url.sub_type && this.primary_url.sub_type === constants.LIST.COLLECTION) label = `${this.details.type ? this.details.screen_name: this.details.name} > Collection`
                    if (this.primary_url.sub_type && this.primary_url.sub_type === constants.LIST.DOSSIER) label = `${this.details.type ? this.details.screen_name: this.details.name} > Dossier`
                    this.primary_url.label = label
                }

                if (!isEmpty(short.backup_url)) {
                    this.backup_url = short.backup_url
                    let label = `${this.details.type ? this.details.screen_name: this.details.name} > overview`
                    if (this.backup_url.sub_type && this.backup_url.sub_type === constants.LIST.COLLECTION) label = `${this.details.type ? this.details.screen_name: this.details.name} > Collection`
                    if (this.backup_url.sub_type && this.backup_url.sub_type === constants.LIST.DOSSIER) label = `${this.details.type ? this.details.screen_name: this.details.name} > Dossier`
                    this.backup_url.label = label
                }

                if(!isEmpty(short.reporting_group)) {
                    let group = short.reporting_group
                    this.reportingGroupValue = group[group.length - 1].name
                    for (let i = 0; i < group.length; i++){
                        this.markedReporting.push(group[i]._id)
                    }
                }
            }
        },

        /**
         * route to member page
         */
         routeToMemberPage (user) {
            if (user && (user._id || user.id)) {
                this.$router.push({name: pageRoutes.usersOverview, params: {id: user._id || user.id}})
            }
        },

        /**
         * route back to previous 
         * page where it came from
         */
        routeToPreviousPage () {
            if (this.prevRoute !== null && this.prevRoute.name && this.prevRoute.name !== this.$route.name) this.$router.push({name: this.prevRoute.name})
            else this.$router.push({name: pageRoutes.shortURLSettingsRegisteredURL})
        },

        /**
         * to fetch reporting groups
         */
        fetchreportingGroups () {
            if (!this.details.id) return
            // body for api
                let body = {
                    entity_id: this.details._id || this.details.id,
                    entity_type: this.details.type || 'ORGANISATION'
                }
            // api call
            getReportingGroups(body)
            .then(response => {
                this.reportingGroups = response.result || []
            }).catch(error => {
                console.error(error)
            })
        },

        fetchCollections (isLoadMore) {
            if (!this.details._id) return
            this.isFetchingCollections = true
            // paarams for api
            let params = {
                skip: this.skip,
                limit: this.limit
            }
            // body for api
            let body = {
                entity_type: this.details.type || 'ORGANISATION',
                entity_id: this.details['_id']|| this.details.id
            }
            // api call
            getMetaCollectionList(body, params)
            .then(response => {
                // if loading more than concat the list
                if (isLoadMore) this.collectionList = this.collectionList.concat(response.items || [])
                // initialise the list
                else this.collectionList = response.items || []
                // increase the skip
                this.skip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMore = false
                }
                // to make fetching false
                this.isFetchingCollections = false
            })
            .catch(() => {
                this.isLoadMore = true
                this.isFetchingCollections = false
                this.skip = 0
            })
        },

        async fetchDossiers (isLoadMore) {
            if (!this.details._id) return
            try {
                this.isFetchingDossiers = true
                // params for api
                let params = {
                    skip: this.dossierSkip,
                    limit: this.limit
                }
                // body for api
                let body = {
                    entity_type: this.details.type || 'ORGANISATION',
                    entity_id: this.details['_id']|| this.details.id
                }
                // api call
                let response = await getMetaDossierList(body, params)
                // if loading more than concat the list
                if (isLoadMore) this.dossierList = this.dossierList.concat(response.items || [])
                // initialise the list
                else {
                    this.dossierList = response.items || []
                    // this.selectedCollection = (response.items && response.items[0]) || {}
                }
                // increase the skip
                this.dossierSkip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMoreDossiers = false
                }
            } catch (error) {
                this.isLoadMoreDossiers = false
            }
            // to make fetching false
            this.isFetchingDossiers = false
        },

        /**
         * infinite loading handler collection
         */
         handleCollectionInfiniteLoading () {
            if (!this.isFetchingCollections && this.isLoadMore) this.fetchCollections(true)
        },

        /**
         * infinite loading handler dossier
         */
        handleDossierInfiniteLoading () {
            if (!this.isFetchingDossiers && this.isLoadMoreDossiers) this.fetchDossiers(true)
        },

        setInternalValue (value, type, isBackup) {
            let object = {}

            switch (type) {
                case constants.LIST.COLLECTION:
                    object = {
                        ...value,
                        type,
                        label: `${this.details.type ? this.details.screen_name: this.details.name} > Collections > ${value.name || ''}`
                    }
                break
                case constants.LIST.DOSSIER:
                    object = {
                        ...value,
                        type,
                        label: `${this.details.type ? this.details.screen_name: this.details.name} > Dossiers > ${value.name || ''}`
                    }
                break
                default:
                    object = {
                        ...value,
                        type_id: this.details._id,
                        type: constants.ORGANISATIONS.ORGANISATION,
                        label: `${this.details.type ? this.details.screen_name: this.details.name} > overview`
                    }
                break
            }

            if (isBackup) this.backup_url = object
            else this.primary_url = object
        },

        /**
         * disable next button
         * @returns is-disabled true/false
         */
         disabledConfirmButton () {
            if (((this.primary === this.INTERNAL && isEmpty(this.primary_url)) || 
            (
                this.redirectionPrimary === this.EXTERNAL && (this.primaryExternalURL === '' || !urlValidation(this.primaryExternalURL) || !this.isPrimaryExternalUrlVerified)))) {
                    return true
            } 
            if (((this.backup === this.INTERNAL && isEmpty(this.backup_url)) || 
                (
                this.backup === this.EXTERNAL && (this.backupExternalURL === '' || !urlValidation(this.backupExternalURL) || !this.isBackupExternalUrlVerified)))) {
                    return true
            } 
                return false
        },

        /**
         * disable test button
         * @returns is-disabled true/false
         */
         disabledTestButtonPrimary () {
            if ((this.primary !== this.EXTERNAL || this.primaryExternalURL === '' || !urlValidation(this.primaryExternalURL))) return true
            return false
        },

        /**
         * disable test button
         * @returns is-disabled true/false
         */
         disabledTestButtonBackup () {
            if ((this.backup !== this.EXTERNAL || this.backupExternalURL === '' || !urlValidation(this.backupExternalURL))) return true
            return false
        },

        async updateShortUrlObject () {
            try {
                loader(this, true)
                // Primary URL object, set the common and expected values
                let primary_url = {
                    type: constants.ORGANISATIONS.ORGANISATION,
                    type_id: this.details._id,
                    redirection_type: this.EXTERNAL,
                    external_url: this.primaryExternalURL
                };

                // If the internal option is chosen, add the values corresponding to it
                if (this.primary === this.INTERNAL) {
                    primary_url.type = constants.ORGANISATIONS.ORGANISATION
                    primary_url.type_id = this.details._id
                    if (this.primary_url.type === constants.LIST.COLLECTION || this.primary_url.type === constants.LIST.DOSSIER) {
                        primary_url.sub_type = this.primary_url.type
                        primary_url.sub_type_id = this.primary_url._id
                    }
                    primary_url.redirection_type = this.INTERNAL
                    delete primary_url.external_url
                }

                // Backup URL object, set the common and expected values
                let backup_url = {
                    type: constants.ORGANISATIONS.ORGANISATION,
                    type_id: this.details._id,
                    redirection_type: this.EXTERNAL,
                    external_url: this.backupExternalURL
                };

                // If the internal option is chosen, add the values corresponding to it
                if(this.backup === this.INTERNAL) {
                    backup_url.type = constants.ORGANISATIONS.ORGANISATION
                    backup_url.type_id = this.details._id
                    if (this.backup_url.type === constants.LIST.COLLECTION || this.backup_url.type === constants.LIST.DOSSIER) {
                        backup_url.sub_type = this.backup_url.type
                        backup_url.sub_type_id = this.backup_url._id
                    }
                    backup_url.redirection_type = this.INTERNAL
                    delete backup_url.external_url
                } 

                // Construct body for api
                let body = {
                    // type: constants.ORGANISATIONS.ORGANISATION,
                    // type_id: this.details._id,
                    // user:  this.userInformation.id,
                    // organisation: this.details._id,
                    primary_url: primary_url,
                    backup_url: backup_url,
                }
                
                // api call
                await updateShortUrl(body, this.short_url._id)
                
                for (let i = 0; i < this.markedReporting.length; i++) {
                    let selctedRows = this.markedReporting[i]
                    const bodyObject = {
                        short_url_ids: [this.$route.params.id]
                    }
                    await updateReportingGroup(bodyObject, selctedRows)
                }

                await this.fetchShortUrl()
                
                // success message
                message(this, constants.messageType.SUCCESS, 'Short URL updated successfully.')
            } catch (error) {
                console.error(error)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            } finally {
                loader(this, false)
                this.openAddShortUrl = false
            }  
        },
        /**
         * test domain
         */
         async testDomain (isBackup) {
            try {
                loader(this, true)
                // body
                let body = {
                    url: isBackup ? this.backupExternalURL : this.primaryExternalURL
                }
                // api call
                let response = await isUrlReachable(body)

                if (isBackup) this.isBackupExternalUrlVerified = response.is_reachable
                else this.isPrimaryExternalUrlVerified = response.is_reachable
            } catch (error) {
                console.warn(error)
            }
            finally {
                loader(this, false)
            }
        },
        toggleReportingGroups(id) {
            if (!this.markedReporting.includes(id)) {
                this.markedReporting.push(id)
            } else {
                const index = this.markedReporting.indexOf(id)
                if (index > -1) {
                    this.markedReporting.splice(index, 1);
                }
            }
        },
    }
}